import { SelectSize, SelectStandard } from '@npco/zeller-design-system'

import * as styled from './BpayToSummary.styled'
import { useBpayToItem } from './useBpayToItem'

export const BpayToSummary = () => {
  const selectedTo = useBpayToItem()

  return (
    <styled.DropdownSummaryWrapper>
      <SelectStandard
        label=""
        size={SelectSize.Large}
        items={[selectedTo]}
        onChange={() => null}
        selectedItem={selectedTo}
      />
    </styled.DropdownSummaryWrapper>
  )
}
